import Skeleton from "@mui/material/Skeleton";

function CategoryWiseSessionSkeleton() {
  return (
    <Skeleton className="rounded-2xl" variant="rectangular" height={400} />
  );
}

export default CategoryWiseSessionSkeleton;
